import { AbstractApiModel } from './abstract-api-model';

export class Tablet extends AbstractApiModel<Tablet> {
  id: number;
  mdmDeviceNumber: string;
  model: string;
  pin: string;
  serialNumber: string;
  robotId: number;


  deserialize(json: any): this {
    this.id = json.id;
    this.mdmDeviceNumber = json.mdm_device_number;
    this.model = json.model;
    this.pin = json.pin;
    this.serialNumber = json.serial_number;
    this.robotId = json.robot_id;

    return super.deserialize(json);
  }

  serialize(): any {
    return Object.assign(super.serialize(), {
      id: this.id,
      mdm_device_number: this.mdmDeviceNumber,
      model: this.model,
      pin: this.pin,
      serial_number: this.serialNumber,
      robot_id: this.robotId,
    });
  }

}
